"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebVitals = void 0;
var _webVitals = require("next/web-vitals");
var _utils = require("../utils");
const capturedMetrics = new Set(['INP', 'LCP', 'CLS']);
const WebVitals = () => {
  (0, _webVitals.useReportWebVitals)(metric => {
    if (capturedMetrics.has(metric.name)) {
      void (0, _utils.reportWebVitals)(metric);
    }
  });
  return null;
};
exports.WebVitals = WebVitals;
